import { useRef, useState } from 'react'
import { useFormContext } from 'react-hook-form';
import { Button, Stack } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { TFilters } from '../../../../../../components/TableDataGridV2/types';
import DisplayDadosClienteFormulario from '../../../MIAnaliseDeCredito/DisplayDadosClienteFormulario';
import PreFiltros from '../../../MIContasPagar/PreFiltrosListagem';
import { headCellsTitulosPagarApGlobal } from '../../../MIContasPagar/PreFiltrosListagem/dataGridConfig';
import { TableDataGridRef, TableDataGridV2 } from '../../../../../../components/TableDataGridV2';
import { IDataListaTitulosPagar } from '../../../../../../types/api/financeiro/pesquisar-titulos-pagar';
export default function Step01({
  selected,
  handleChangeSelected
}: Step01Props) {

  const { getValues, setValue } = useFormContext();

  const preFilter = getValues('preFilterStep')
  const [preFilters, setPreFilters] = useState<TFilters>({})
  const [contaContabil, setContaContabil] = useState<string | null>(null);
  const tableRef = useRef<TableDataGridRef>(null)

  //funcoes manipuladoras
  const handleNext = () => {
    if (tableRef.current) {
      const selectedRows = tableRef.current.getSelectedRows();
      if (selectedRows.length === 0) {
        enqueueSnackbar('Por favor, selecione pelo menos um título.', { variant: 'warning' })
        return
      }

      handleChangeSelected(selectedRows)
      const nextStep = getValues('funcoesAux.onNext');
      nextStep();
    }
  };

   const handleSelectionChange = (selectedRows: IDataListaTitulosPagar[]) => {
    setContaContabil(selectedRows[0]?.conta_contabil);
  };

  return (
    <>
      {
        preFilter &&
        <PreFiltros
          filtros={preFilters}
          onSubmitFilters={(values) => {
            setPreFilters(values)
            setValue('preFilterStep', false)
          }}
        />
      }

      {
        !preFilter &&
        <>
          {
            (preFilters?.tipo_publico_pesquisar && preFilters?.codigo_publico_pesquisar) &&
            <DisplayDadosClienteFormulario
              tipoDado='param'
              tipo={preFilters.tipo_publico_pesquisar}
              codigo={preFilters.codigo_publico_pesquisar}
            />
          }

          <TableDataGridV2
            ref={tableRef}
            columns={headCellsTitulosPagarApGlobal}
            url="/financeiro/contas-pagar/pesquisar-titulos-pagar"
            queryKey="listar-todos-titulos-pagar"
            enableSelection={true}
            pagination="server"
            queryParams={{
              data_pagamento_is_null: true,
              ap_global_contem: [0],
              conta_contabil_contem: contaContabil ? [contaContabil] : null,
            }}
            preFilledFilters={preFilters}
            handleUpdatePreFilters={(value) => setPreFilters(value)}
            selectedFields={['id', 'tipo_publico', 'codigo_publico', 'saldo_principal', 'numero_documento', 'tipo_documento','serie_documento' ,'sequencia_documento','nome_publico', 'data_vencimento', 'conta_contabil']}
            onSelectionChange={handleSelectionChange}
          />

        </>
      }

      {
        !preFilter &&
        <Stack direction={'row'} justifyContent={'flex-end'} mt={1}>
          <Button
            variant="contained"
            onClick={() => {
              handleNext();
            }}
          >
            Avançar
          </Button>
        </Stack>
      }
    </>
  )
}

interface Step01Props {
  handleChangeSelected: (value: readonly string[]) => void
  selected: readonly string[]
}
